export const OPEN_MOBILENAVMENU = 'OPEN_MOBILENAVMENU';
export const CLOSE_MOBILENAVMENU = 'CLOSE_MOBILENAVMENU';

export const OPEN_PHONEMENU = 'OPEN_PHONEMENU';
export const CLOSE_PHONEMENU = 'CLOSE_PHONEMENU';

export const OPEN_SUBMENU = 'OPEN_SUBMENU';
export const CLOSE_SUBMENU = 'CLOSE_SUBMENU';

export const CLOSE_MENUS = 'CLOSE_MENUS';

export const TOGGLE_ZIPMODAL = 'TOGGLE_ZIPMODAL';
export const TOGGLE_STICKY_EMAIL_GUIDE = 'TOGGLE_STICKY_EMAIL_GUIDE';

export const UPDATE_TOGGLE = 'UPDATE_TOGGLE';
export const UPDATE_ADOBE_TESTING = 'UPDATE_ADOBE_TESTING';
export const UPDATE_PC_CENSUS = 'UPDATE_PC_CENSUS';

export const openMobileNavMenu = () => {
    return {
        type: OPEN_MOBILENAVMENU,
    };
};

export const closeMobileNavMenu = () => {
    return {
        type: CLOSE_MOBILENAVMENU,
    };
};

export const openPhoneMenu = () => {
    return {
        type: OPEN_PHONEMENU,
    };
};

export const closePhoneMenu = () => {
    return {
        type: CLOSE_PHONEMENU,
    };
};

export const openSubMenu = (menu: string) => {
    return {
        type: OPEN_SUBMENU,
        payload: menu,
    };
};

export const closeSubMenu = () => {
    return {
        type: CLOSE_SUBMENU,
    };
};

export const closeMenus = () => {
    return {
        type: CLOSE_MENUS,
    };
};

export const toggleZipFormModal = (data: boolean) => {
    return {
        type: TOGGLE_ZIPMODAL,
        payload: data,
    };
};

export const toggleStickyEmailGuide = (data: boolean) => {
    return {
        type: TOGGLE_STICKY_EMAIL_GUIDE,
        payload: data,
    };
};

export const updateToggle = (toggleActive: boolean) => {
    return {
        type: UPDATE_TOGGLE,
        payload: { toggleActive },
    };
};

export const updateAdobeTesting = (data: {
    adobeHasLoaded: boolean;
    adobeContentRenderingStart: boolean;
    adobeTestData: {
        tools?: string;
        personalcode?: string;
    };
    adobeExperiences?: Array<{ testName: string; testVariant: string; testIsRedirect: boolean }>;
}) => {
    return {
        type: UPDATE_ADOBE_TESTING,
        payload: data,
    };
};

export const updatePcCensus = (data: {
    errorType: string;
    modalOpen: boolean;
    modalInfo: {
        title: string;
        message: string;
        redirectURL?: string;
    };
    redirectParams: Record<string, string>;
}) => {
    return {
        type: UPDATE_PC_CENSUS,
        payload: data,
    };
};
